<template>
    <div class="max-w-[700px] mx-auto">
        <hts-form
            class="w-full"
            @submit="handleSubmit">
            <hts-card class="pt-2">
                <div>
                    <span class="text-base block pt-5 font-medium text-default-500">
                        {{ $t('labels.moocSavingPolicy') }}
                    </span>
                    <div class="pl-10 grid gap-4 grid-cols-1 sm:grid-cols-2">
                        <hts-form-input
                            v-model="dataPolicy.freeHourNumber"
                            :label="$t('labels.freeHourNumber')"
                            type="number"
                            required
                            :color="props.color"
                            name="keepMoocByHours"
                            prop="keepMoocByHours" />
                        <hts-form-input
                            v-model="dataPolicy.moocKeepHourly"
                            :label="$t('labels.moocKeepHourly')"
                            type="number"
                            required
                            :color="props.color"
                            name="moocKeepHourly"
                            prop="moocKeepHourly" />
                        <hts-form-input
                            v-model="dataPolicy.moocKeepOvernight"
                            :label="$t('labels.moocKeepOvernight')"
                            type="number"
                            required
                            :color="props.color"
                            name="moocKeepOvernight"
                            prop="moocKeepOvernight" />
                        <hts-form-date
                            v-model="dataPolicy.calculatedByHourNextDay"
                            :label="$t('labels.calculatedByHourNextDay')"
                            type="time"
                            required
                            :color="props.color"
                            name="calculatedByHourNextDay"
                            prop="calculatedByHourNextDay" />

                        <hts-form-input
                            v-model="dataPolicy.moocKeepLongTerm"
                            :label="$t('labels.moocKeepLongTerm')"
                            type="number"
                            required
                            :color="props.color"
                            name="moocKeepLongTerm"
                            prop="moocKeepLongTerm" />
                        <hts-form-input
                            v-model="dataPolicy.calculatedFromEvening"
                            :label="$t('labels.moocKeepLongTermCalculatedFromEvening')"
                            type="number"
                            required
                            :color="props.color"
                            name="calculatedFromEvening"
                            prop="calculatedFromEvening" />
                    </div>
                    <span class="text-base block pt-5 font-medium text-default-500">
                        {{ $t('labels.holidaySurchargePolicy') }}
                    </span>
                    <div class="pl-10 grid gap-4 grid-cols-1 sm:grid-cols-22">
                        <hts-form-input
                            v-model="dataPolicy.towingContainerSunday"
                            :label="$t('labels.towingContainerSunday')"
                            type="number"
                            required
                            :color="props.color"
                            name="towingContainerSunday"
                            prop="towingContainerSunday" />
                        <hts-form-input
                            v-model="dataPolicy.towingContainerHoliday"
                            :label="$t('labels.towingContainerHoliday')"
                            type="number"
                            required
                            :color="props.color"
                            name="towingContainerHoliday"
                            prop="towingContainerHoliday" />
                    </div>
                    <span class="text-base block pt-5 font-medium text-default-500">
                        {{ $t('labels.reeferPluginCharges') }}
                    </span>
                    <div class="pl-10 grid gap-4 grid-cols-1 sm:grid-cols-2">
                        <hts-form-input
                            v-model="dataPolicy.reeferPluginChargesGenerator"
                            :label="$t('labels.reeferPluginChargesGenerator')"
                            type="number"
                            required
                            :color="props.color"
                            name="reeferPluginChargesGenerator"
                            prop="reeferPluginChargesGenerator" />
                    </div>
                </div>

                <div>
                    <hts-form-button
                        class="text-right"
                        icon-name="hi-clipboard-document-check-icon"
                        icon-position="right"
                        color="primary"
                        type="submit">
                        {{ $t('labels.save') }}
                    </hts-form-button>
                </div>
            </hts-card>
        </hts-form>
    </div>
</template>

<script lang="ts" setup>
import { IGlobalSettingPolicy } from './ignore/imports/form'
const emits = defineEmits(['updateData'])
const { $disableReactive } = useNuxtApp()

const dataPolicy = ref<IGlobalSettingPolicy>({
  freeHourNumber: null,
  moocKeepHourly: null,
  moocKeepOvernight: null,
  calculatedByHourNextDay: null,
  moocKeepLongTerm: null,
  calculatedFromEvening: null,
  towingContainerSunday: null,
  towingContainerHoliday: null,
  reeferPluginChargesGenerator: null
})
const props = defineProps({
  globalSettingsInformation: {
    type: Object,
    default: () => {}
  }
})
const { globalSettingsInformation } = toRefs(props)

const store = $store()

const handleSubmit = () => {
  const api = $url.settings.updatePolicySettings
  $api(api, { body: { policy: dataPolicy.value } })
    .then((data) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (responseData.success) {
        store.globalSettings.setGlobalSettings(responseData.data)
        emits('updateData')
        process.client && $toast().success($t('notifications.updateSuccess'))
      }
    })
    .catch(() => {
      process.client && $toast().error($t('notifications.updateError'))
    })
}
onMounted(() => {
  Object.assign(dataPolicy.value, $disableReactive(globalSettingsInformation.value.policy))
})
</script>

<style scoped></style>
